import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HelpDTO } from '../model/help.model';
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class HelpService {
  PATH = 'api/help';
  private readonly http = inject(HttpClient);

  getHelp(locale: string): Observable<HelpDTO> {
    return this.http.get<HelpDTO>(`${this.PATH}?locale=${locale}`);
  }

  saveHelp(help: HelpDTO) {
    return this.http.post(`${this.PATH}`, help);
  }
}
